import axiosInstance from "@/services/axiosInstance";
import type { Supplier } from "@/types/api/data-contracts";

class MySuppliers {
    // eslint-disable-next-line no-use-before-define
    private static instance: MySuppliers;

    public static getInstance(): MySuppliers {
        if (!MySuppliers.instance) {
            MySuppliers.instance = new MySuppliers();
        }
        return MySuppliers.instance;
    }

    listSuppliers(
        brandId: string,
        filter?: { page?: number | null; search?: string }
    ) {
        const url = `/companies/brands/${brandId}/my-suppliers/`;
        return axiosInstance.get(url, { params: { ...filter } });
    }

    getDetails(brandId: string, companyId: string) {
        const url = `/companies/brands/${brandId}/my-suppliers/${companyId}/`;
        return axiosInstance.get(url);
    }

    requestNewSupplier(
        data: FormData | Record<string, any>
    ): Promise<Supplier> {
        const url = `/companies/buyer/supplier-requests/`;

        // If FormData (has file), use multipart/form-data
        if (data instanceof FormData) {
            return axiosInstance.post(url, data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
        }

        // Otherwise send as JSON (default Content-Type: application/json)
        return axiosInstance.post(url, data);
    }
}

export default MySuppliers;
